import { comics } from "@/mocks/comics";

const trending = ["剑起沧澜", "都市隐龙", "灵狐传", "山河绘卷", "食戟之战", "机甲纪元"];

export default function Hero() {
  const featured = comics.slice(0, 3);

  return (
    <section id="home" className="relative overflow-hidden">
      <div className="relative h-[720px] md:h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=dynamic%20stylized%20chinese%20manga%20collage%20scene%20with%20swordsmen%20mechas%20and%20fantasy%20creatures%20in%20a%20vibrant%20warm%20orange%20and%20coral%20palette%2C%20abstract%20energetic%20comic%20art%2C%20dramatic%20sunlight%20rays%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=mm-hero-bg&orientation=landscape"
          alt="漫漫漫画门户背景图"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 to-transparent"></div>

        <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col items-start justify-center px-4 md:px-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
            <i className="ri-fire-fill text-accent-500"></i>
            海量漫画全集 · 一网打尽
          </span>
          <h1 className="font-heading mt-6 max-w-3xl text-4xl font-bold leading-tight text-background-50 md:text-6xl">
            漫漫漫画大全
            <br />
            <span className="text-accent-500">全集分类目录</span> 随心看
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            聚合全站漫画大全与全集目录，分类清晰、合集丰富。从热门连载到冷门佳作，漫漫漫画全部收录，找漫不迷路。
          </p>

          <div className="mt-8 w-full max-w-xl">
            <form
              className="flex flex-col gap-3 sm:flex-row sm:items-center sm:rounded-full sm:bg-white sm:p-1.5"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="flex items-center gap-2 rounded-full bg-white px-4 py-3 sm:flex-1 sm:bg-transparent sm:p-2">
                <i className="ri-search-line text-lg text-foreground-400"></i>
                <input
                  type="text"
                  name="keyword"
                  placeholder="搜索你想看的漫画名称…"
                  className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
              <button
                type="submit"
                className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                立即搜索
              </button>
            </form>
          </div>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-sm text-background-200">大家都在搜：</span>
            {trending.map((t) => (
              <a
                key={t}
                href="#hot"
                className="whitespace-nowrap rounded-full bg-white/10 px-3 py-1 text-sm text-background-100 transition-colors hover:bg-white/20 hover:text-background-50"
              >
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 mx-auto -mt-24 max-w-7xl px-4 pb-6 md:px-6">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {featured.map((c, i) => (
            <a
              key={c.id}
              href="#hot"
              className="group flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50/95 p-3 backdrop-blur transition-all hover:border-primary-200"
            >
              <div className="relative h-24 w-16 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={c.cover}
                  alt={`${c.title} 漫画封面`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-1 top-1 rounded bg-primary-500 px-1.5 text-xs font-bold text-background-50">
                  0{i + 1}
                </span>
              </div>
              <div className="min-w-0">
                <h3 className="truncate text-base font-semibold text-foreground-950">{c.title}</h3>
                <p className="mt-1 text-sm text-primary-600">{c.chapter}</p>
                <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-fill text-accent-500"></i>
                    {c.readers}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500"></i>
                    {c.score}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}